import MuiPopover from "@mui/material/Popover";
import type { PopoverProps as MuiPopoverProps } from "@mui/material/Popover";

export interface PopoverProps extends Omit<MuiPopoverProps, "open"> {
  open?: boolean;
}

export function Popover({ id, open, onClose, anchorOrigin, anchorEl, children }: PopoverProps) {
  return (
    <MuiPopover
      id={id}
      open={open ?? Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      anchorEl={anchorEl}
    >
      {children}
    </MuiPopover>
  );
}
